import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiEventManager } from 'ng-jhipster';
import { ConfirmationModelService } from 'src/app/shared/confirmation-modal/confirmation-model.service';
import { FutureDataType } from 'src/app/shared/model/future_data_type.model';
import { IUnderwriterMySuffix } from 'src/app/shared/model/underwriter-my-suffix.model';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
import { UnderwriterMySuffixService } from './underwriter-my-suffix.service';




@Component({
    selector: 'jhi-underwriter-my-suffix-delete-dialog',
    templateUrl: './underwriter-my-suffix-delete-dialog.component.html'
})
export class UnderwriterMySuffixDeleteDialogComponent {
    underwriter: IUnderwriterMySuffix;
    futureStatus: boolean = false;
    isConfirmed: boolean = false;

    constructor(
        private underwriterService: UnderwriterMySuffixService,
        public activeModal: NgbActiveModal,
        private eventManager: JhiEventManager,
        private futureRecordService: ConfirmationModelService
        
    ) {}

    clear() {
        this.activeModal.dismiss('cancel');
    }

    setFutureStatus(futureStatus) {
        this.futureStatus = futureStatus;
    }

    confirmDelete(id: number) {
        this.isConfirmed = true;
        if (this.futureStatus) {
            this.updateExistedFutureRecordStatus(id);
        }
        this.underwriterService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'underwriterListModification',
                content: 'Deleted an underwriter'
            });
            this.activeModal.dismiss(true);
        },(err=>{
            this.activeModal.dismiss(true);
        }));
    }

    updateExistedFutureRecordStatus(id: number) {
        this.futureRecordService.updateExistedFutureRecordStatus({
            masterId: this.underwriter.id,
            futureDataType: FutureDataType.UNDERWRITER.valueOf(),
            fromEffectiveDateFormatted: this.underwriter.fromEffectiveDate,
            masterStatus : this.underwriter.activeStatus == 'ACTIVE' ? 'IN_ACTIVE' : 'ACTIVE',
        }).subscribe(response => {
            console.log(response.body);
        });
    }
}

@Component({
    selector: 'jhi-underwriter-my-suffix-delete-popup',
    template: ''
})
export class UnderwriterMySuffixDeletePopupComponent implements OnInit, OnDestroy {
    private ngbModalRef: NgbModalRef;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private modalService: NgbModal,
        private languageChangeService: LanguageChangeService
    ) {
        this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    ngOnInit() {
        this.activatedRoute.data.subscribe(({ underwriter }) => {
            setTimeout(() => {
                this.ngbModalRef = this.modalService.open(UnderwriterMySuffixDeleteDialogComponent as Component, {
                    size: 'lg',
                    backdrop: 'static'
                });
                this.ngbModalRef.componentInstance.underwriter = underwriter;
                this.ngbModalRef.result.then(
                    result => {
                        //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/underwriter']));
                        this.ngbModalRef = null;
                    },
                    reason => {
                        //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/underwriter']));
                        this.ngbModalRef = null;
                    }
                );
            }, 0);
        });

        
       
    }

    ngOnDestroy() {
        this.ngbModalRef = null;
    }
}
